import {getRequest} from '@/utils/api'
import {postRequest} from "../../utils/api";


// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
   return getRequest("/dict/listByDictType/"+dictType)
}


export function getDictByParam(dictType,parentValue) {
  let obj = {"dictType":dictType,"parentValue":parentValue}
  return postRequest("/dict/listByParam",obj);
}





// WEBPACK FOOTER //
// ./src/api/sys/dict.js